import { spin, hexToRgba } from '../../../utils/style';
import styled, { css } from 'styled-components';
import { Format, NewStyleColor } from '../../../utils/styles-constants';
import { Button } from '../../../components/Button/styles';
import { ParametersPageButton } from '../../../components/ParametersPage/styles';
import { ButtonHTMLAttributes } from 'react';

const DeleteButtonVariants: ({}) = {
	['Bar']: styled(Button)`
		border-color: ${NewStyleColor.Red200};
		color: ${NewStyleColor.Red200};
		margin: 20px 5px;

		& > svg {
			height: 35px;
			width: 35px;
			fill: ${NewStyleColor.Red200};
		}

		@media ${Format.Smartphone} {
			flex-basis: 25%;
		}

		@media (hover: hover) {
			&:hover {
				background-color: ${NewStyleColor.Red200};
				border-color: ${NewStyleColor.Red200};
				color: ${NewStyleColor.White};
			}
		}
	`,
	['Icon']: styled('div')`
		cursor: pointer;
		& > svg {
			height: 30px;
			width: 30px;
		}`,
	['ParametersPage']: styled(ParametersPageButton)`${css`
		background-color: ${NewStyleColor.Red200}};
		color: ${NewStyleColor.White};
		opacity: ${(props: ButtonHTMLAttributes<HTMLButtonElement>) => props.disabled ? 0.4 : 1};

		& > div {
			display: flex;
			flex-flow: row nowrap;
			align-items: center;
			width: 100%;

			& > svg {
				position: relative;
				left: 5px;
				height: 25px;
				width: 25px;
				animation: ${spin};
			}

			& > span {
				margin: auto;
			}
		}

		@media (hover: hover) {
			&:hover {
				background-color: ${hexToRgba(NewStyleColor.Red200, 10)};
				color: ${hexToRgba(NewStyleColor.White, 50)};
			}
		}
	`}`
};

export { DeleteButtonVariants };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/DeleteButton/styles.ts